import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

import { MainContext, ShopContext } from '../../store/contexts';
import { ToastNotifications } from '../notifications/ToastNotifications';
import { CategoriesNav } from '../categories/CategoriesNav';
import { ShopNavbar } from '../shop/ShopNavbar';
import { ShopFooter } from '../shop/ShopFooter';

export const ShopLayout = () => {
    const { categories } = useContext(MainContext);
    const user = useSelector((state) => state.auth.user);

    return (
        <ShopContext.Provider value={{ categories }}>
            <div className="main-layout d-flex flex-column min-vh-100">
                <main className="main-page flex-shrink-0 mb-auto">
                    <ShopNavbar user={user}>
                        <CategoriesNav {...categories} />
                    </ShopNavbar>
                    <div className="container-fluid">
                        <div className="container">
                            <Outlet />
                        </div>
                        <ToastNotifications />
                    </div>
                </main>
                <ShopFooter />
            </div>
        </ShopContext.Provider>
    );
};
